import React, { useState, useEffect } from 'react'
import {
  Button,
  Row,
  Col,
  Panel,
  Checkbox,
  CheckboxGroup,
  Message,
  Radio,
  RadioGroup,
} from 'rsuite'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { useForm, Controller } from 'react-hook-form'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  proposalProjectSubmitVerify,
  proposalProjectSubmitConfirm,
  getproposalProjectSubmitPdf,
  doUpdatePersonId,
} from '../../redux/actions/submitProposal'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import COIValidateWidget from '../coi/COIValidateWidget'
import { RETRY_CONTACT_ADMIN } from '../../constants/msgText'
import KycMessage from '../../components/message/kycMessage/KycMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import AIEvaluationResultWidget from '../aiEvaluation/AIEvaluationResultWidget'

import AIEvaluationResultHistoryWidget from '../aiEvaluation/AIEvaluationResultHistoryWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import AIEvaluationProcessWidget from '../aiEvaluation/AIEvaluationProcessWidget'

export default function SubmitProposlWidget(props) {
  const {
    schema,
    schemaPdpa,
    hideSpecialOrganization,
    finalSubmitButtonText = 'ยืนยันการยื่นข้อเสนอโครงการ',
    alwaysEnableFinalSubmitButton,
    isAIEvaliation,
  } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [isVerifyError, setIsVerifyError] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [disableFinalSubmitButton, setDisableFinalSubmitButton] = useState(
    schema.speccialOrganization ? true : false
  )
  const [showModalFinalConfirm, setShowModalFinalConfirm] = useState(false)
  const [verifyMessage, setVerifyMessage] = useState('')

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const { register, handleSubmit, watch, errors, control, setValue, clearErrors, getValues } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)
  const [formSchemaPdpa, setFormSchemaPdpa] = useState(schemaPdpa)
  const [evaluationResultSchema, setEvaluationResultSchema] = useState()
  const [previewPdf, setPreviewPdf] = useState()
  const [consistencySelected, setConsistencySelected] = useState([])
  const [documentSelected, setDocumentSelected] = useState([])
  const [showVerifyConfirm, setShowVerifyConfirm] = useState(false)
  const [request, setRequest] = useState()
  const [pdpaValue, setPdpaValue] = useState(false)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)
  const [contractTypeValue, setContractTypeValue] = useState('0')
  const [consentResult, setConsentResult] = useState()
  const [personId, setPersonId] = useState()

  const [evalOpen, setEvalOpen] = useState()
  const [isContinue, setIsContinue] = useState()

  useEffect(() => {
    if (projectId) {
      handleGetProjectSubmitPdf(projectId)
      // handleGetEvaluation()
    }
  }, [projectId])

  useEffect(() => {
    if (!schema?.consistency?.optionSelected || schema?.consistency?.optionSelected?.length === 0) {
      setValue(schema.consistency.name, null)
    } else {
      setValue(schema.consistency.name, schema?.consistency?.optionSelected)
      setConsistencySelected(schema?.consistency?.optionSelected)
    }
    if (!schema?.consistency?.optionSelected || schema?.document?.optionSelected?.length === 0) {
      setValue(schema.document.name, null)
    } else {
      setValue(schema.document.name, schema?.document?.optionSelected)
      setDocumentSelected(schema?.document?.optionSelected)
    }
  }, [schema])

  useEffect(() => {
    const th_consent_callback = (result) => {
      // console.log('Consent data:', JSON.stringify(result))
      setConsentResult(result)
    }

    window.th_consent_callback = th_consent_callback

    return () => {
      delete window.th_consent_callback
    }
  }, [])

  useEffect(() => {
    // console.log('consentResult : ', consentResult)

    if (consentResult) {
      var personId = consentResult.data?.PersonId

      if (personId) {
        handleUpdatePersonId(personId)
      }

      let acceptPDPA = new Map()

      formSchemaPdpa.info?.consentIds?.forEach((elm) => {
        let consent = consentResult.data.Consents?.find((item) => item.CconsentId == elm)
        let notaccepted = consent?.ConsentItems.find((item) => item.AcceptStatus != 1)
        acceptPDPA.set(elm, !notaccepted ? true : false)
      })

      var isAccept = true
      for (const [key, value] of acceptPDPA) {
        console.log(`${key}: ${value}`)
        if (!value) {
          isAccept = false
          break
        }
      }

      setPersonId(personId)
      setPdpaValue(isAccept)
      setConsentResult()
    }
    // else {
    //   setPdpaValue(false)
    // }
  }, consentResult)

  const handleGetProjectSubmitPdf = async (projectId) => {
    //startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await getproposalProjectSubmitPdf(projectId)
      // console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      // console.error('error => ', e)
      setIsPdfError(true)
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    //doneLoading()
    setShowModalFinalConfirm(false)
  }

  const handleProposalProjectSubmitVerify = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsVerifyError(false)
    try {
      const response = await proposalProjectSubmitVerify(projectId, request)
      if (response.success) {
        setVerifyMessage(response.title)
        setIsVerifyError(false)
        setDisableFinalSubmitButton(false)
      } else {
        setVerifyMessage(response.title)
        setIsVerifyError(true)
      }
    } catch (e) {
      // console.error('error => ', e)
      setIsVerifyError(true)
    }
    setIsLoading(false)
    doneLoading()
    setShowVerifyConfirm(false)
  }

  const handleProposalProjectSubmitConfirm = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setShowModalFinalConfirm(false)
    try {
      const request = {
        acceptPDPA: pdpaValue || false,
        contractType: contractTypeValue,
      }

      const response = await proposalProjectSubmitConfirm(projectId, request)
      if (response.projectVersionId) {
        //jump to success page
        await dispatch(getSchemaSidebar(response.projectVersionId))
        setIsLoading(false)
        doneLoading()
        setShowModalFinalConfirm(false)
        sessionStorage.setItem('projectId', response.projectVersionId)
        sessionStorage.setItem('param', '')
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(true)
      }
    } catch (e) {
      // console.error('error => ', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
    setShowModalFinalConfirm(false)
  }

  const handleUpdatePersonId = async (personId) => {
    startLoading()
    setIsLoading(true)
    try {
      await doUpdatePersonId(projectId, personId)
    } catch (e) {}
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('submit data', data)
    let request = {
      consistentSelected: data.consistency,
      documenttSelected: data.document,
    }
    setRequest(request)
    setShowVerifyConfirm(true)
    //handleProposalProjectSubmitVerify(request)
  }

  const handleChangeConsistencyCheckbox = (optionSelected) => {
    if (isRequired(formSchema.consistency.validators) && optionSelected.length === 0) {
      setValue(formSchema.consistency.name, null)
    } else {
      setValue(formSchema.consistency.name, optionSelected)
      clearErrors(formSchema.consistency.name)
    }

    setFormSchema((state) => ({
      ...state,
      consistency: {
        ...state.consistency,
        optionSelected: optionSelected,
      },
    }))

    setConsistencySelected(optionSelected)
  }

  const handleChangeDocumentCheckbox = (optionSelected) => {
    if (isRequired(formSchema.document.validators) && optionSelected.length === 0) {
      setValue(formSchema.document.name, null)
    } else {
      setValue(formSchema.document.name, optionSelected)
      clearErrors(formSchema.document.name)
    }

    setFormSchema((state) => ({
      ...state,
      document: {
        ...state.document,
        optionSelected: optionSelected,
      },
    }))

    setDocumentSelected(optionSelected)
  }

  const finalSubmit = () => {
    let request = {
      id: formSchema.id,
      projectVersionId: projectId,
      userId: 'string',
      consistentSelected: formSchema.consistency.optionSelected,
      documenttSelected: formSchema.document.optionSelected,
    }
    handleProposalProjectSubmitConfirm(request)
  }

  const getPDPAConsent = async () => {
    startLoading()
    setIsLoading(true)
    try {
      let req = {
        PersonId: formSchemaPdpa.info.personId || personId || '',
        SiteKey: formSchemaPdpa.info.siteKey,
        ConsentIds: formSchemaPdpa.info.consentIds,
        uniqueId: formSchemaPdpa.info.email, //localStorage.getItem('thp_user_uid') || '',
        PersonName: formSchemaPdpa.info.name,
      }

      th_consent_get(req)
    } catch (e) {
      // console.error('error => ', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const consistencyCheckbox = formSchema.consistency.options.map((item, index) => {
    return (
      <Checkbox
        value={item.value}
        key={index}
        disabled={item.disabled || !disableFinalSubmitButton}
      >
        {item.label}
      </Checkbox>
    )
  })

  const documentCheckbox = formSchema.document.options.map((item, index) => {
    return (
      <Checkbox
        value={item.value}
        key={index}
        disabled={item.disabled || !disableFinalSubmitButton}
      >
        <div dangerouslySetInnerHTML={{ __html: item.label }}></div>
      </Checkbox>
    )
  })

  return (
    <>
      {isLoading && <OverlayLoader />}

      {!hideSpecialOrganization && formSchema.speccialOrganization && (
        <Panel
          style={{ marginBottom: 10 }}
          header={formSchema.header}
          collapsible
          defaultExpanded
          shaded
        >
          <CustomIconMessageInfo content={formSchema.messageInfo} />
          {formSchema.consistency && (
            <div>
              <p style={{ marginTop: 10 }}>
                <b>{formSchema.consistency.header}</b>
              </p>
              <ErrorMessage error={errors[formSchema.consistency.name]} />
              <Controller
                key={formSchema.consistency.name}
                name={formSchema.consistency.name}
                control={control}
                rules={isValidators(formSchema.consistency.validators)}
                defaultValue={consistencySelected}
                render={(props) => {
                  return (
                    <CheckboxGroup
                      value={consistencySelected || []}
                      onChange={handleChangeConsistencyCheckbox}
                    >
                      {consistencyCheckbox}
                    </CheckboxGroup>
                  )
                }}
              />
            </div>
          )}

          <p style={{ marginTop: 10 }}>
            <b>{formSchema.document.header}</b>
          </p>
          <ErrorMessage error={errors[formSchema.document.name]} />
          <Controller
            key={formSchema.document.name}
            name={formSchema.document.name}
            control={control}
            rules={isValidators(formSchema.document.validators)}
            defaultValue={documentSelected}
            render={(props) => {
              return (
                <CheckboxGroup
                  value={documentSelected || []}
                  onChange={handleChangeDocumentCheckbox}
                >
                  {documentCheckbox}
                </CheckboxGroup>
              )
            }}
          />

          <p style={{ marginTop: 10 }}>
            <b>{formSchema.confirmText}</b>
          </p>
          {verifyMessage && (
            <Message
              showIcon
              type={isVerifyError ? 'error' : 'success'}
              description={verifyMessage}
            />
          )}
          <br />
          <Button
            style={{ width: 200 }}
            appearance="ghost"
            disabled={!disableFinalSubmitButton}
            onClick={handleSubmit(onSubmit)}
          >
            ยืนยันแบบตรวจสอบ
          </Button>
        </Panel>
      )}

      <Panel shaded>
        {!pdpaValue && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="warning" description={formSchemaPdpa.message} />
          </Row>
        )}

        {/* COI */}
        <div style={{ marginBottom: 30, marginTop: 20 }}>
          <COIValidateWidget
            disabled={formSchema.ProjectFilterSummary?.proposalFilter?.disabled || isLoading}
            isCOIPass={isCOIPass}
            setIsCOIPass={setIsCOIPass}
            checkCOI={checkCOI}
            setCheckCOI={setCheckCOI}
            setIsCheckCOI={setIsCheckCOI}
            setCheckInterest={setCheckInterest}
            checkInterest={checkInterest}
            fixType={'1'}
            isBold={true}
          />
        </div>

        <Row style={{ marginBottom: 10 }}>
          {schema.contractType && (
            <Col xs={24} sm={24} md={24} lg={24}>
              <ErrorMessage error={errors[schema.contractType.name]} />
              <Controller
                name={schema.contractType.name}
                control={control}
                defaultValue={schema.contractType.value || '0'}
                // rule={register(isValidators(schema.contractType.validators))}
                render={(props) => {
                  return (
                    <RadioGroup
                      name={schema.contractType.name}
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        setContractTypeValue(value)
                      }}
                    >
                      {schema.contractType?.options &&
                        schema.contractType.options.map((item) => (
                          <Radio key={item.value} value={item.value}>
                            {item.label}
                          </Radio>
                        ))}
                    </RadioGroup>
                  )
                }}
              />
            </Col>
          )}

          {contractTypeValue == '1' && schema.verifyKyc && (
            <Col xs={24} sm={24} md={24} lg={24}>
              <KycMessage schema={schema.verifyKyc} />
            </Col>
          )}
        </Row>

        <Row style={{ marginBottom: 10, marginTop: 20 }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <b>
              3. การคุ้มครองข้อมูลส่วนบุคคล (PDPA) รายละเอียดตามลิ้งนี้{' '}
              <a href={formSchemaPdpa.info?.link} target="_blank">
                Privacy Notice
              </a>
            </b>
            {/* {formSchemaPdpa.readPdpa} */}
          </Col>
        </Row>
        <Row style={{ marginBottom: 10, textAlign: 'center' }}>
          <Col xs={24} sm={24} md={8} lg={8} style={{ textAlign: 'center' }}>
            <ViewButton
              block
              style={{ minWidth: 200, maxWidth: 300 }}
              disabled={(disableFinalSubmitButton && !alwaysEnableFinalSubmitButton) || isLoading}
              onClick={() => {
                getPDPAConsent()
              }}
              icon="character-authorize"
              children="ขอความยินยอม"
            />
          </Col>
        </Row>

        {isAIEvaliation ? (
          <>
            <Row style={{ marginBottom: 10, marginTop: 20 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <b>4. ประเมินคุณภาพข้อเสนอโครงการ และ {finalSubmitButtonText}</b>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'center' }}>
                <SaveButton
                  block
                  style={{ marginTop: 10, minWidth: 200, maxWidth: 300 }}
                  icon="send"
                  disabled={
                    (contractTypeValue == '1' && !!schema.verifyKyc) ||
                    (disableFinalSubmitButton && !alwaysEnableFinalSubmitButton) ||
                    isLoading ||
                    !pdpaValue ||
                    !isCOIPass ||
                    !checkCOI
                  }
                  onClick={() => setEvalOpen(true)}
                  children={'ประเมินคุณภาพข้อเสนอโครงการ'}
                />
              </Col>
            </Row>

            {evalOpen && (
              <AIEvaluationProcessWidget
                start={evalOpen}
                updateProcess={setEvalOpen}
                setEvaluationResultSchema={setEvaluationResultSchema}
              />
            )}

            {!evalOpen && (
              <>
                {evaluationResultSchema && (
                  <>
                    <AIEvaluationResultWidget
                      schema={evaluationResultSchema}
                      onContinue={(val) => setIsContinue(val)}
                      isSend={true}
                    />
                  </>
                )}

                {evaluationResultSchema &&
                  ((evaluationResultSchema.score || 0) >=
                    (evaluationResultSchema.minimumScore || 0) ||
                    isContinue) && (
                    <SaveButton
                      block
                      style={{ marginTop: 10, minWidth: 200, maxWidth: 300 }}
                      icon="send"
                      onClick={() => setShowModalFinalConfirm(true)}
                      children={finalSubmitButtonText}
                    />
                  )}
              </>
            )}

            <AIEvaluationResultHistoryWidget hideWhenNoData />
          </>
        ) : (
          <Row style={{ marginBottom: 10, marginTop: 20 }}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <b>4. {finalSubmitButtonText}</b>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'center' }}>
              <SaveButton
                block
                style={{ marginTop: 10, minWidth: 200, maxWidth: 300 }}
                icon="send"
                disabled={
                  (contractTypeValue == '1' && !!schema.verifyKyc) ||
                  (disableFinalSubmitButton && !alwaysEnableFinalSubmitButton) ||
                  isLoading ||
                  !pdpaValue ||
                  !isCOIPass ||
                  !checkCOI
                }
                onClick={() => setShowModalFinalConfirm(true)}
                children={finalSubmitButtonText}
              />
            </Col>
          </Row>
        )}

        <hr />
        {/* <br /> */}
        {isError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={'ยืนยันไม่สำเร็จ ' + RETRY_CONTACT_ADMIN} />
          </Row>
        )}
        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF  ' + RETRY_CONTACT_ADMIN} />
        ) : (
          <>
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              isShaded={false}
              onReload={() => handleGetProjectSubmitPdf(projectId)}
              loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF ข้อเสนอโครงการ..."
              firstExpandToReload
            />
          </>
        )}
      </Panel>
      <br />

      <ConfirmWidget
        title={`ยืนยันแบบตรวจสอบ`}
        show={showVerifyConfirm}
        detail={`ยืนยันแบบตรวจสอบ`}
        onCancle={() => setShowVerifyConfirm(false)}
        onConfirm={() => handleProposalProjectSubmitVerify(request)}
      />

      <ConfirmWidget
        title={`${finalSubmitButtonText}`}
        show={showModalFinalConfirm}
        detail={`${finalSubmitButtonText}`}
        onCancle={() => setShowModalFinalConfirm(false)}
        onConfirm={handleProposalProjectSubmitConfirm}
      />

      <div id="th-popup-consent" className="th-popup" />
    </>
  )
}
